import { Ref, watch } from 'vue';
import { FieldHtmlNameUtil, HekateDisplayForm } from 'www-shared';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class EduAcademicWebinarProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    super.realtimeBranchModifications({ formDefinition });
    const schoolLevelField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.schoolLevel });
    schoolLevelField.componentName = 'hidden-field';

    const roleFieldVal = ExternalUtil.findDisplayFieldValOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.eduRole });

    watch(roleFieldVal, (newVal) => {
      const showHiddenField = (newVal === 'Student' || newVal === 'Educator');
      if (showHiddenField) {
        schoolLevelField.componentName = 'single-select-field';
        schoolLevelField.isRequired = true;
      } else {
        schoolLevelField.componentName = 'hidden-field';
        schoolLevelField.isRequired = false;
      }
    });
  }
}
